import { Grid, Stack } from "@mui/material";
import React from "react";
import { SectionTitle } from "./SectionTitle";
import { ControlledTextField } from "../forms/ControlledTextField";
import { ControlledCountryPhoneField } from "../forms/ControlledCountryPhoneField";
import { CheckoutFormTypeFields, useCheckoutForm } from "./hooks/useCheckoutForm";
import { OrderPersonalInformationFields } from "../../types/purchaseOrder/Order";
import { CHECKOUT_MAXLEN } from "../../utils/checkoutFieldMaxLengths";
import type { CheckoutFormType } from "./hooks/useCheckoutForm";
import type { Path } from "react-hook-form";

export const PersonalInformationSection: React.FC = () => {
    const { methods } = useCheckoutForm();
    const baseName = CheckoutFormTypeFields.PersonalInformation;

    const countryCodeName =
        `${baseName}.${OrderPersonalInformationFields.AreaCode}` as Path<CheckoutFormType>;

    const phoneName =
        `${baseName}.${OrderPersonalInformationFields.PhoneNumber}` as Path<CheckoutFormType>;

    return (
        <Stack mb={2}>
            <SectionTitle>Datos Personales</SectionTitle>

            <Grid container spacing={2}>
                <Grid size={12}>
                    <ControlledTextField
                        control={methods.control}
                        label={"Nombre"}
                        name={`${baseName}.${OrderPersonalInformationFields.FirstName}`}
                        required
                        inputProps={{ maxLength: CHECKOUT_MAXLEN.vchNombre }}
                    />
                </Grid>

                <Grid size={12}>
                    <ControlledTextField
                        control={methods.control}
                        label={"Apellido"}
                        name={`${baseName}.${OrderPersonalInformationFields.LastName}`}
                        required
                        inputProps={{ maxLength: CHECKOUT_MAXLEN.vchApellido }}
                    />
                </Grid>

                <Grid size={{ xs: 12, md: 12, lg: 4 }}>
                    <ControlledTextField
                        control={methods.control}
                        label={"DNI"}
                        name={`${baseName}.${OrderPersonalInformationFields.Document}`}
                        required
                        inputProps={{
                            maxLength: CHECKOUT_MAXLEN.vchDocumento,
                            inputMode: "numeric",
                            pattern: "[0-9]*",
                        }}
                    />
                </Grid>

                <Grid size={{ xs: 12, md: 12, lg: 8 }}>
                    <ControlledCountryPhoneField<CheckoutFormType>
                        control={methods.control}
                        getValues={methods.getValues}
                        setValue={methods.setValue}
                        trigger={methods.trigger}
                        countryCodeName={countryCodeName}
                        phoneName={phoneName}
                        required
                        phoneMaxLength={CHECKOUT_MAXLEN.vchTelefono}
                        defaultCountryIso2="AR"
                        phoneHelperText={
                            'Ingresá código de área y número. Ej AR celular: " 9 11 1234 5678".'
                        }
                    />
                </Grid>
            </Grid>
        </Stack>
    );
};














